import { API } from '@Providers';
import type { EquipmentRentalAgreementOption } from '../types/equipmentRental.types';

interface GetEquipmentRentalRentalAgreementsResponse {
  data?: {
    rental_agreements?: EquipmentRentalAgreementOption[];
  };
  rental_agreements?: EquipmentRentalAgreementOption[];
}

function normalizeRentalAgreements(
  response: GetEquipmentRentalRentalAgreementsResponse
): EquipmentRentalAgreementOption[] {
  const list = response?.data?.rental_agreements ?? response?.rental_agreements;
  return Array.isArray(list) ? list : [];
}

export default async function getEquipmentRentalRentalAgreementsService(): Promise<EquipmentRentalAgreementOption[]> {
  const endpoint = '/api/shelter/settings/equipment-rental/rental-agreements';
  const response = (await API({ endpoint })) as GetEquipmentRentalRentalAgreementsResponse;
  return normalizeRentalAgreements(response);
}
